<template>

  <div class="px-4 py-2 container-fluid">
    <div class="card ficha-buscador pt-0 mt-4 mb-4">
      <div class="titulo" style="width:100%;"><h5 class="mb-0">Configuración</h5></div>
      <p class="px-4">Límites biométricos normales:</p>
      <Form role="form" class="text-start p-4 pt-0" @submit="handleConfiguracion">
        <div>
          <label for="min_oxigeno" class="form-label" style="line-height:25px;height:30px;width:210px;display:inline-block;">Umbral mínimo oxígeno(%)</label>
          <soft-field id="min_oxigeno" v-model="configura.min_oxigeno" value="3" type="number" min="0" max="100" step="0.1" name="min_oxigeno" class="mb-2" style="width:200px;display:inline-block;"/>
        </div>
        <div>
          <label for="min_pulsacion" class="form-label" style="line-height:25px;height:30px;width:210px;display:inline-block;">Rango pulsaciones(ppm)</label>
          <soft-field id="min_pulsacion" v-model="configura.min_pulsacion" type="number" min="0" max="200" step="1" name="min_pulsacion" class="mb-2" style="width:200px;display:inline-block;"/>
          <soft-field id="max_pulsacion" v-model="configura.max_pulsacion" type="number" min="0" max="200" step="1" name="max_pulsacion" class="mb-2 ps-2" style="width:200px;display:inline-block;"/>
        </div>
        <div>
          <label for="min_temperatura" class="form-label" style="line-height:25px;height:30px;width:210px;display:inline-block;">Rango temperatura(ºC)</label>
          <soft-field id="min_temperatura" v-model="configura.min_temperatura" type="number" min="0" max="100" step="0.1" name="min_temperatura" class="mb-2" style="width:200px;display:inline-block;"/>
          <soft-field id="max_temperatura" v-model="configura.max_temperatura" type="number" min="0" max="100" step="0.1" name="max_temperatura" class="mb-2 ps-2" style="width:200px;display:inline-block;"/>
        </div>
        <div>
          <label for="horas_borrado" class="form-label" style="line-height:25px;height:30px;width:210px;display:inline-block;">Tiempo anonimización biométrica(h)</label>
          <soft-field id="horas_borrado" v-model="configura.horas_borrado" type="number" min="0" max="100" step="0.1" name="horas_borrado" class="mb-2" style="width:200px;display:inline-block;"/>
        </div>
        <div class="text-center mt-5">
          <soft-button class="my-2 mb-2 text-sm" color="analiza-azul" full-width :is-disabled="loading ? true : false">
              <span v-if="loading" class="spinner-border spinner-border-sm"></span>
              <span v-else>Confirmar</span>
          </soft-button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import showSwal from "@/mixins/showSwal.js";
import SoftField from "@/components/SoftField.vue";
import SoftButton from "@/components/SoftButton.vue";
import { Form } from "vee-validate";

export default {
  name: "Configuracion",
  components: {
    Form,
    SoftField,
    SoftButton
  },
  mixins: [],
  data() {
    const configura = {
        min_oxigeno: "",
        min_pulsacion: "",
        max_pulsacion: "",
        min_temperatura: "",
        max_temperatura: "",
        horas_borrado: ""
    };
    return {
      configura: configura,
      loading: false,
    };
  },

  methods: {
    alert() {
      showSwal.methods.showSwal({
        type: "error",
        message: "This is a PRO feature.",
        width: 400,
      });
    },
    async handleConfiguracion() {
      // Aquí puedes realizar acciones cuando se envía el formulario
      this.loading = true;
      try {             
          const resp = await this.$store.dispatch("auth/guardaConfiguracion", this.configura);
          this.loading = false;
          if (resp.res=='OK') {
              showSwal.methods.showSwal({
                  type: "success",
                  message: "Se ha registrado el nuevo departamento",
                  width: 600,
              });
              this.$emit('cerrar-modal');
          }
          else {
              showSwal.methods.showSwal({
                  type: "error",
                  message: resp.mensaje,
                  width: 500
              });               
          }
      } catch (error) {
          this.loading = false;
          showSwal.methods.showSwal({
              type: "error",
              message: "Se ha producido un error",
              width: 500,
          });
      }
    },

    async obtenerConfiguracion() { 
      try {
        const resp = await this.$store.dispatch("auth/configuracion"); 
        this.configura = {
          min_oxigeno: resp.min_oxigeno ?? '',
          min_pulsacion: resp.min_pulsacion ?? '',
          max_pulsacion: resp.max_pulsacion ?? '',
          min_temperatura: resp.min_temperatura ?? '',
          max_temperatura: resp.max_temperatura ?? '',
          horas_borrado: resp.horas_borrado ?? ''
        };
        console.log('Tengo', this.configura);
      } 
      catch (error) {
        showSwal.methods.showSwal({
            type: "error",
            message: "Se ha producido un error",
            width: 500,
        });
      }
    },

    irInicio() {
      this.$router.push('/profile');
    }
  },

  async mounted() { 
    setTimeout( () => {
      this.obtenerConfiguracion();
    },200);
  },

};
</script>



<style lang="scss" scoped>
.alertas {
  background-color: rgba(0, 176, 234, 0.5);
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;

  .modal-content {
    display: flex;
    flex-direction: column;

    h1,
    p {
      margin-bottom: 16px;
    }

    h1 {
      font-size: 32px;
    }

    p {
      font-size: 18px;
    }
  }
}
</style>
